export default __webpack_public_path__ + "static/media/zoom_in.34a38bbf.svg";